import React, {Component, Fragment} from 'react';
import {Expansion} from "./Expansion";
import {Input} from "./Input";
import {insertParam} from "../utils";
import {Select} from "./Select";
import {Button} from "./Button";
export default class  VehicleFiltersTopbar extends Component {


    renderCount() {
        let count = 0;
        for (let prop in this.props.filters) {
            count += this.props.filters[prop].activeCount();
        }
        return count;
    }

    onClickFilter = (filter) => {
        this.props.changeFilter(filter);
    }
    render() {
        const { toggle, filters, customFilters, stateFilters } = this.props;
        const quickFiltersTitle = "QUICK FILTERS:";

        return (
            <Fragment>
                <div
                    className={`vehicles-filters__topBar filters-tabs-section filters-tabs-section--dark ${
                        customFilters.length === 0 ? "hide-display-mobile" : ""
                    }`}>
                    {customFilters.length > 0 ? (<p className={`filter-heading hide-display-desktop`}>{quickFiltersTitle}</p>) : null}
                    <div className="filters-tabs-section__wrap">
                        <div className="filters-tabs-section__list hide-display-mobile vehicles-filters__filters-topbar--trigger-container">
                            <div
                                onClick={toggle}
                                className={`vehicles-filters__filters-topbar--trigger`}
                            >
                                    <span
                                        data-count={this.renderCount()}
                                        className={
                                            this.renderCount() == 0
                                                ? "no-count"
                                                : undefined
                                        }
                                    >
                                        Filters
                                    </span>
                            </div>
                        </div>

                        <div className="filters-tabs-section__list hide-display-mobile">
                            <div className="vehicles-filters__expansion" style={{margin: `20px`}}>
                                <Input
                                    {...filters.keywords.field}
                                    name="keywords"
                                    className={` notGreyPlaceholder `}
                                    modifiers={["filter", "search-left"]}
                                    placeholder="Keyword Search"
                                    curvedRadius={true}
                                    darkBackground={true}

                                />

                            </div>
                        </div>

                        <div className="filters-tabs-section__list filter-buttons-list">
                            <div className={`hide-display-mobile`}>
                                {customFilters.length > 0 ? (<p className={`filter-heading`}>{quickFiltersTitle}</p>) : null}
                            </div>
                            <div className={`filters-tabs-section__list`}>
                                {customFilters.map((filter, index) => (
                                    <div style={{marginRight: `20px`}}>
                                        <div
                                            className={`vehicles-filters__filters-topbar--quick-filter-trigger`}
                                            style={{
                                                color: 'White',
                                                border: stateFilters[filter['name']] ? '1px solid rgba(255, 255, 255, 1)' : '1px solid rgba(159, 159, 159, 1)'
                                            }}
                                            onClick={() => {
                                                this.onClickFilter(filter)
                                            }}
                                            key={index}>
                                            <span
                                                className={`${stateFilters[filter['name']] ? "icon_yellow" : "icon_grey"} trigger-text`}
                                            >
                                                {filter.label}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="filters-tabs-section__list hide-display-mobile vehicles-filters__filters-topbar--trigger-container">
                            <Button
                                title={`Value my car`}
                                modifiers={['solid', 'medium','white']}
                                chevron={true}
                                data-controller="popup-form"
                                data-form="make-trade-enquiry"
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
